import { ReactNode } from 'react';

import { Slide } from '@mui/material';

import {
  Button,
  IconButton,
  Icons,
  Typography,
  Box,
  Stack,
  tokens,
} from '@cast/design-system';

type ManualCredentialsSectionProps = {
  securityConstruct: string;
  input: ReactNode;
  apiError: string | undefined;
  isSubmitting: boolean;
  isEnteringManually: boolean;
  setIsEnteringManually: (value: boolean) => void;
};

export const ManualCredentialsSection = ({
  securityConstruct,
  input,
  apiError,
  isSubmitting,
  isEnteringManually,
  setIsEnteringManually,
}: ManualCredentialsSectionProps) => {
  return (
    <Box overflow="hidden" pt={16}>
      {isEnteringManually ? (
        <Slide in mountOnEnter unmountOnExit>
          <Stack>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={8}
            >
              <Typography variant="P12B">
                Add {securityConstruct} manually
              </Typography>

              <IconButton
                variant="ghost"
                size="sm"
                onClick={() => setIsEnteringManually(false)}
                disabled={isSubmitting}
                testId="close-manual-inputs-button"
              >
                <Icons.X />
              </IconButton>
            </Box>

            {isEnteringManually && (
              <Stack>
                {input}
                {!!apiError && (
                  <Typography
                    variant="P12R"
                    color="red.500"
                    data-testid="manual-input-api-error"
                  >
                    {apiError}
                  </Typography>
                )}
              </Stack>
            )}
          </Stack>
        </Slide>
      ) : (
        <Box display="flex" alignItems="center" gap={4}>
          <Typography
            variant="P12R"
            color={tokens.theme.fg.structural.secondary}
          >
            Add {securityConstruct}
          </Typography>
          <Button
            variant="text"
            onClick={() => setIsEnteringManually(true)}
            testId="open-manual-inputs-button"
          >
            manually
          </Button>
        </Box>
      )}
    </Box>
  );
};
